import { PlusIcon, PencilSquareIcon, ArrowUpTrayIcon } from "@heroicons/react/24/solid";
import { ExportIcon } from "assets/icons";

function ThumbButton({
  size,
  role,
  className,
  ...props
}: {
  size?: string;
  role: string;
  className?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  let sizeClass = 'bg-brand-purple bottom-20 right-4 border-b-2 border-brand text-white h-14 w-14 shadow-lg rounded-2xl';
  if(size === 'secondary') { sizeClass = 'bg-brand-pale bottom-40 right-4 mb-1 mr-1.5 h-11 w-11 shadow rounded-lg text-brand-electric' }
  return (
    <button className={`${sizeClass} md:hidden flex items-center justify-center fixed z-[9] ` + className} {...props}>
      { role === 'add' && <PlusIcon className="h-6 w-6"/>}
      { role === 'edit' && <PencilSquareIcon className="h-6 w-6"/>}
      { role === 'upload' && <ArrowUpTrayIcon className="h-6 w-6"/>}
      { role === 'export' && <ExportIcon className="h-5 w-5"/>}
    </button>
  );
}

export default ThumbButton;
